<div class="menu-category-desktop">
  <div class="container">
    <cx-page-layout section="navigation"></cx-page-layout>
  </div>
</div>
